import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import {
  ApproveButton,
  ButtonWrapper,
  ErrorText,
  PendingApprovalLabel
} from '../css';
import request from '../../utils/request';

const UserDeleted = ({ userId, fetchUsers }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleAction = async () => {
    setError(false);
    setLoading(true);
    try {
      const result = await request.post(`/users/restore`, { id: userId });
      if (result) fetchUsers();
    } catch (err) {
      setLoading(false);
      setError(true);
      throw err;
    }
  };

  return (
    <Spinner label="Restoring..." show={loading}>
      <PendingApprovalLabel>
        Users profile is deleted. Restore?
      </PendingApprovalLabel>
      <ButtonWrapper>
        <ApproveButton onClick={handleAction}>Restore</ApproveButton>
      </ButtonWrapper>
      {error && (
        <ErrorText>Error occurred while restoring the user profile</ErrorText>
      )}
    </Spinner>
  );
};

UserDeleted.propTypes = {
  userId: PropTypes.string.isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export default UserDeleted;
